import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assets: [], // assets
  activeAssetId: null, // current selected asset
};

const assetSelectorSlice = createSlice({
  name: "asset_selector",
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    setAssets: (state, action) => {
      state.assets = action.payload;
    },
    setActiveAssetId: (state, action) => {
      state.activeAssetId = action.payload;
    },
    setActiveAssetByName: (state, action) => {
      const { assetName } = action.payload;
      const asset = state.assets.find(
        (asset) => asset.asset_name === assetName
      );
      state.activeAssetId = asset.id;
    },
    setAssetWells: (state, action) => {
      const { assetId, wells } = action.payload;
      const asset = state.assets.find(
        (asset) => asset.id === assetId
      );
      asset.wells = wells;
    },
  },
});

export const {
  reset,
  setAssets,
  setActiveAssetId,
  setActiveAssetByName,
  setAssetWells,
} = assetSelectorSlice.actions;

export const selectAssets = (state) => state.asset_selector.assets;

export const selectAssetById = (state, assetId) => {
  if (assetId == null || state.asset_selector.assets == null) return null;
  return state.asset_selector.assets.find((asset) => asset.id === assetId);
};

export const selectActiveAssetId = (state) =>
  state.asset_selector.activeAssetId;

export const selectActiveAsset = (state) => {
  if (state.asset_selector.activeAssetId == null) return null;
  return state.asset_selector.assets.find(
    (asset) => asset.id === state.asset_selector.activeAssetId
  );
};

export const selectAssetWells = (state, assetId) => {
  const asset = state.asset_selector.assets.find((asset) => asset.id === assetId);
  return asset ? asset.wells : null;
};

export const selectActiveWells = (state) => {
  let wells = [];
  const assetId = state.asset_selector.activeAssetId;
  if (assetId != null) {
    const asset = state.asset_selector.assets.find((asset) => asset.id === assetId);
    if (asset && asset.wells) {
      wells = asset.wells
    }
  }
  return wells;
};

export const selectWellByAssetAndId = (state, assetId, wellId) => {
  if (
    assetId == null ||
    wellId == null ||
    state.asset_selector.assets == null
  )
    return null;
  let asset = state.asset_selector.assets.find((asset) => asset.id === assetId);
  if (asset && asset.wells) {
    const well = asset.wells.find((well) => well.uwi === wellId);
    if (well) return well;
  }
  return null;
};

export const selectWellById = (state, wellId) => {
  if (wellId == null || state.asset_selector.assets == null) return null;
  for (const asset of state.asset_selector.assets) {
    if (asset && asset.wells) {
      const well = asset.wells.find((well) => well.uwi === wellId);
      if (well) return well;
    }
  }
  return null;
};

export default assetSelectorSlice.reducer;
